<template>
  <div class="div2 cutbox">
    <div class="text1">
      <span data-id="短特点1" data-range="3,7">{{ info.specialty_short[0] }}</span>|
      <span data-id="短特点2" data-range="3,7">{{ info.specialty_short[1] }}</span>|
      <span data-id="短特点3" data-range="3,7">{{ info.specialty_short[2] }}</span>
    </div>
    <div class="text2" data-id="主标题1" data-range="6,8">{{ info.titles[0] }}</div>
    <div class="text3" data-id="长特点1" data-range="15,33">{{ info.specialty[0] }}</div>
    <div class="text4"><img :src="info.image" alt=""></div>
    <div class="text5" data-id="长特点2" data-range="9,13" v-html="addspan(info.specialty[1])"></div>
    <div class="text6" data-id="公司" data-range="8,19">{{ info.company }}</div>
  </div>
</template>
<script>
export default {
  name: 'TUWEN002',
  props: {
    info: Object
  },
  methods: {
    addspan(str) {
      let res = "";
      for (let i in str) {
        if (i == 0 || i == 7) {
          res += '<span>' + str[i];
        }
        else if (i == 1 || i == 8) {
          res += str[i] + '</span>';
        }
        else { res += str[i] }
      }
      return res;
    },
  },
}
</script>
